<script lang="ts">
import { defineComponent, ref } from 'vue'

import ButtonIcon from '@/molecules/ButtonIcon.vue'
import { toggleGlobalAudio, useAudio } from '@/utils/audio'

export default defineComponent({
  name: 'ButtonSound',
  components: {
    ButtonIcon
  },
  setup () {
    const audio = useAudio('click')
    const enabled = ref(false)
    const handleClick = () => {
      audio.play()
      enabled.value = !enabled.value
      toggleGlobalAudio()
    }

    return {
      enabled,
      handleClick
    }
  }
})
</script>

<template>
  <ButtonIcon
    :icon="enabled ? 'sound-on' : 'sound-off'"
    :data-track-cta-name="`Toggle audio: ${enabled ? 'ON' : 'OFF'}`"
    @click="handleClick"
  />
</template>
